import { render, staticRenderFns } from "./alseActivity.vue?vue&type=template&id=5156bdeb"
import script from "./alseActivity.vue?vue&type=script&lang=js"
export * from "./alseActivity.vue?vue&type=script&lang=js"
import style0 from "./alseActivity.vue?vue&type=style&index=0&id=5156bdeb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports